export type SinglePageCheckoutRoutesParams = {
  orderNumber: string;
  paymentToken?: string;
};

export class SinglePageCheckoutRoutes {
  static readonly paths = {
    order: "order",
    orderSuccess: "success",
    orderPaymentFailed: "payment-failed",
  };

  static readonly params = {
    orderNumber: "orderNumber",
    paymentToken: "paymentToken",
    orderStatus: "order-status",
  };

  static get orderRootRoute(): string {
    return `/${this.paths.order}/:${this.params.orderNumber}`;
  }

  static get orderFailedPaymentRoute(): string {
    return `${this.orderRootRoute}/${this.paths.orderPaymentFailed}`;
  }

  static get thankYouPageRoute(): string {
    return `${this.orderRootRoute}/${this.paths.orderSuccess}/:${this.params.paymentToken}?`;
  }

  static getOrderRootRoute(orderNumber: string): string {
    return `/${this.paths.order}/${orderNumber}`;
  }

  static getOrderFailedPaymentPath(orderNumber: string): string {
    return `/${this.paths.order}/${orderNumber}/${this.paths.orderPaymentFailed}`;
  }

  static getThankYouPagePath(orderNumber: string, paymentToken?: string): string {
    const pathSuffix = paymentToken ? `/${paymentToken}` : "";

    return `/${this.paths.order}/${orderNumber}/${this.paths.orderSuccess}${pathSuffix}`;
  }
}
